<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <finance-payout-cebuana *ngIf="menuHomeEnumActive === _menuHomeEnum.CebuanaPayout"
                            [menuPermissionActive]="menuPermissionActive"
                            [onboardingTabMenu]="onboardingTabMenu">
    </finance-payout-cebuana>
    <finance-payout-online-transfer *ngIf="menuHomeEnumActive === _menuHomeEnum.OnlineTransfer"
                                    [menuPermissionActive]="menuPermissionActive"
                                    [onboardingTabMenu]="onboardingTabMenu">
    </finance-payout-online-transfer>
</div>
